<template>
  <div class="auth-container">
    <div class="auth-card">
      <h2>Sign In</h2>
      <div class="sso-signin">
        <button @click="signInWithSSO" :disabled="loading" class="sso-button">
          {{ loading ? 'Redirecting...' : 'Sign In with SSO' }}
        </button>
        <p class="sso-description">
          You will be redirected to your organization's sign-in page
        </p>
      </div>
      <div v-if="error" class="error">{{ error }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { signInWithRedirect } from 'aws-amplify/auth';
import { useTheme } from '../composables/useTheme';

// Initialize theme
const { theme } = useTheme();

onMounted(() => {
  // Ensure theme is applied to document
  document.documentElement.setAttribute('data-theme', theme.value);
});

const emit = defineEmits(['authenticated']);

const loading = ref(false);
const error = ref('');

const signInWithSSO = async () => {
  loading.value = true;
  error.value = '';
  try {
    // Use current origin for OAuth redirect
    const currentOrigin = window.location.origin;
    await signInWithRedirect({ 
      provider: { custom: 'ManagementAccountSAML' },
      customState: currentOrigin
    });
  } catch (err) {
    error.value = err.message || 'Failed to redirect to SSO';
    loading.value = false;
  }
};
</script>

<style scoped>
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--bg-color);
  color: var(--text-color);
}

.auth-card {
  background-color: var(--modal-bg);
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
  color: var(--text-color);
  border: 1px solid var(--border-color);
}

.auth-card h2 {
  color: var(--text-color);
  text-align: center;
  margin-bottom: 1.5rem;
}

.sso-signin {
  text-align: center;
}

.sso-button {
  width: 100%;
  padding: 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.sso-button:hover:not(:disabled) {
  background: #0056b3;
}

.sso-button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.sso-description {
  color: var(--text-color);
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.8;
}

.error {
  color: #dc3545;
  margin-top: 1rem;
  text-align: center;
}
</style>